import { render } from "./gsrcu010101.vue?vue&type=template&id=4a8cf0d8&scoped=true"
import script from "./gsrcu010101.vue?vue&type=script&lang=js"
export * from "./gsrcu010101.vue?vue&type=script&lang=js"

import "./gsrcu010101.vue?vue&type=style&index=0&id=4a8cf0d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8cf0d8"]])

export default __exports__